import React, { useCallback, useContext, useEffect, useState } from "react";
import ReactDOM from "react";

import { Loading } from "../SVG";
import { HibModal } from "../HibModal"
import WebServiceContext from "../../webService/WebServiceContext";

import { Document, DocumentProps, Page, pdfjs, } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import { PDFDocumentProxy } from 'pdfjs-dist/types/src/display/api';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type PDFModalProps = {
    fileName: string
}

/*
type NoticeObj = {
    RecordCount: number
    TypeName: string
    //isOpen: boolean
}*/


type LoadCallback = Required<DocumentProps>['onLoadSuccess']

const PDFContent = (props: PDFModalProps) => {
    const ws = useContext(WebServiceContext)
    const [PDF, setPDF] = useState<string>("")    
    const [isLoading, setIsLoading] = useState<boolean>(true)
    
    const [currentPages, setCurrentPages] = useState<number>(1) 
    const [numPages, setNumPages] = useState<number>(0) 

    const [scale, setScale] = useState<number>(1) 

    useEffect(() => {
        
        if (props.fileName) {
            setIsLoading(true)
            setPDF("")
            ws.webservice.asyncGetFile(props.fileName).then((res: any) => {
                console.log(res)
                setIsLoading(false)
                setPDF(res.toString())
            })
        }
    }, [props.fileName])

    const onDocumentLoadSuccess: LoadCallback = useCallback((pdf) => {
        setNumPages(pdf.numPages);
    }, [])

    const changeSize = (act:string)=>{
        if(act == "+"){
            (scale + 0.1) < 5 && setScale(scale+0.1)
        }else{
            (scale - 0.1) > 0.4 && setScale(scale-0.1)
        }
    }

    const downloadPDF = ()=>{
        const link = document.createElement('a');
        link.href = "data:application/pdf;base64," + PDF;
        link.setAttribute(
          'download',
          `${props.fileName}.pdf`,
        );
        document.body.appendChild(link);
        link.click();
    
    }

    return (
        <>
        <div className="PDFContent">
            {
                isLoading &&
                <div className="loadingBox">
                    <Loading />
                </div>
            }
            <Document
                className="PDFbody"
                file={"data:application/pdf;base64," + PDF}
                onLoadSuccess={onDocumentLoadSuccess}
            >
                {
                     Array.apply(null, new Array(numPages)).map(( empty:any, index:number)=>
                        <Page key={"PDFpage_"+index} width={800} scale={scale} className="PDFpage" pageNumber={index+1} />
                     )
                }
            </Document>
            <div className="PDFToolBar">
                {
                    /**
                     <button className="hibBtn small main">上一頁</button>
                     */
                }
                {/*
                    Array.apply(null, new Array(numPages)).map((empty:any, index:number)=>{
                        return( 
                            <button 
                                className="hibBtn main small" 
                                onClick={()=>{setCurrentPages(index+1)}}
                            >
                                {index+1}
                            </button>
                        )
                    })
                */}
                {/**
                <button className="hibBtn small main">下一頁</button>
                 */}
            </div>
        </div>
        <div className="PDFToolBar">
            {/**
             * 
            <div>
                <input type="range" value={scale} min={0.2} max={3} step={0.1}
                    onChange={(event:React.ChangeEvent<HTMLInputElement>)=>{
                        setScale(parseFloat(event.target.value))
                    }}
                />
            </div>
            */}
            <button className="hibBtn main"
                onClick={()=>{ changeSize("-") }}
            >縮小</button>
            <button className="hibBtn main"
                onClick={()=>{ downloadPDF() }}
            >下載</button>
            <button className="hibBtn main"
                onClick={()=>{ changeSize("+") }}
            >放大</button>
        </div>
        </>

    )

}


export default PDFContent